import { CloseSVG, mqUp } from 'rwl-ui';
import { CloseButton } from '../CloseButton';
import { closeSidebar } from './utils';
import styled from '@emotion/styled';

const SidebarCloseButtonContainer = styled.div`
    position: absolute;
    top: 0;
    right: -8px;
    ${mqUp('md')} {
        display: none;
    }
`;

export const SidebarCloseButton = () => {
    return (
        <SidebarCloseButtonContainer>
            <CloseButton onClick={closeSidebar}>
                <CloseSVG />
            </CloseButton>
        </SidebarCloseButtonContainer>
    );
};
